/**
 * Cognit brain glyph — a stylized brain SVG inside a rounded gradient square.
 * Used as the app's logo everywhere.
 */
import { motion } from "framer-motion";

export default function BrainLogo({ size = 26, className = "", animate = true }) {
  const props = animate
    ? { whileHover: { rotate: 10, scale: 1.06 }, transition: { type: "spring", stiffness: 320, damping: 16 } }
    : {};
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={`brain-glow ${className}`}
      {...props}
    >
      <defs>
        <linearGradient id={`bl-${size}`} x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7C5CFF" />
          <stop offset="1" stopColor="#5AC8FA" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="8" fill={`url(#bl-${size})`} />
      {/* Stylized brain — two hemispheres */}
      <g stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" fill="none">
        {/* center divide */}
        <path d="M16 8.5 V23" opacity="0.85" />
        {/* left hemisphere */}
        <path d="M16 8.5 C13 8 11 9.2 10 11.2 C8.4 11.6 7.5 13 7.8 14.6 C6.6 15.4 6.6 17 7.8 17.8 C7.5 19.4 8.6 21 10.5 21.2 C11.4 22.6 13.2 23.4 16 23" />
        <path d="M10.5 12.6 Q12 13.2 12.8 14.6" opacity="0.7" />
        <path d="M9.4 16 Q11 16.4 12 17.6" opacity="0.7" />
        <path d="M11 19.4 Q12.4 19.2 13 20" opacity="0.7" />
        {/* right hemisphere */}
        <path d="M16 8.5 C19 8 21 9.2 22 11.2 C23.6 11.6 24.5 13 24.2 14.6 C25.4 15.4 25.4 17 24.2 17.8 C24.5 19.4 23.4 21 21.5 21.2 C20.6 22.6 18.8 23.4 16 23" />
        <path d="M21.5 12.6 Q20 13.2 19.2 14.6" opacity="0.7" />
        <path d="M22.6 16 Q21 16.4 20 17.6" opacity="0.7" />
        <path d="M21 19.4 Q19.6 19.2 19 20" opacity="0.7" />
      </g>
    </motion.svg>
  );
}
